import {create} from 'zustand';
import {persist} from 'zustand/middleware';

export const WHERE_SEARCH_STORE_KEY = 'where-search-store';

interface WhereSearchItem {
  id: number;
  whereType: string;
  whereValue: string;
  originalValue: string;
}

interface WhereSearchState {
  whereSearches: WhereSearchItem[];
  addWhereSearch: (item: WhereSearchItem) => void;
}

export const useWhereSearchStore = create(
  persist<WhereSearchState>(
    set => ({
      whereSearches: [],

      // 추가 (최대 3개)
      addWhereSearch: item =>
        set(state => {
          return {
            whereSearches: [item, ...state.whereSearches.filter(search => search.whereValue !== item.whereValue)].slice(
              0,
              3,
            ),
          };
        }),
    }),
    {
      name: WHERE_SEARCH_STORE_KEY,
    },
  ),
);
